import Box from '@mui/material/Box'
import ContentGuide from 'global/guides/ContentGuide'
import React from 'react'
import { useSearchParams } from 'react-router-dom'

import ToolbarLog from '../atoms/Toolbar'
import { columns } from '../constants/columns'
import { useFetchLog } from '../services/useFetchLog'

const LogsMesDatagrid: React.FC = () => {
    const [searchParams] = useSearchParams()

    const clienteId = searchParams.get('clienteId')
    const operacao = searchParams.get('operacao')

    const { data, isLoading } = useFetchLog({
        queryParams: {
            clienteId,
            operacao,
            datetime: 'month',
        },
        enabled: true,
    })

    return (
        <Box
            role="panel"
            id="logs-tabpanel-4"
            aria-labelledby="logs-tab-4"
            height="100%"
        >
            <ContentGuide.DataGrid
                columns={columns}
                rows={data?.sort(
                    (a: any, b: any) =>
                        new Date(b.createdAt).getTime() -
                        new Date(a.createdAt).getTime(),
                )}
                loading={isLoading}
                components={{
                    Toolbar: ToolbarLog,
                }}
            />
        </Box>
    )
}

export default LogsMesDatagrid
